import { Guid } from 'guid-typescript';

export class GuidHelper {
  static getGuid(): string {
    return Guid.create().toString();
  }

  static parse(guid: string): string {
    return Guid.parse(guid).toString();
  }
}
